import Document from "../../components/Document";
function DocumentPage() {
  return (
    <div>
      <Document />
    </div>
  );
}

export default DocumentPage;
